<template>
  <div id="headPage" class="headPage" :style="{backgroundImage:`url(${HbackgroundURL})`} " style="    background-size: contain;">
  
        <!-- //zo--分隔线-- -->
        <div class="header-title ">
            <div class="header-logo">
              <img :src= titleCheckData.HlogoURL class="Hlogoimg" alt="深圳医院" 
                  v-if="titleCheckData.HlogoURL"/>
            </div>
            <div class="header-menu" v-if="!$root.is_mobile">
              <span v-for="(nav_item, index) in nav_list" :key="index" 
                  class="menu-item" 
                  v-bind:class="{'active-nav': currentMenuIndex==nav_item.id,'hover-nav': hoverNavIndex==nav_item.id}"
                  v-on:mouseover="hoverNavIndex = index" 
                  v-on:mouseout="hoverNavIndex = -1"
                  v-on:click="change_page(index)">
                {{nav_item.nav_name}}
              </span>
            </div>
            <div class="head-button flex">
              <div>
                <el-button round size="mini" type="primary" v-on:click="login()">登录
                </el-button>
              </div>
              <div id="sys-user" class="sys-icons-menu" v-if="$root.is_mobile">
                <div class="icons-menu_nav flex icons-menu-size"  title="菜单"  v-on:click="showNav()" >
                </div>
              </div>
            </div>
        </div>
              

  </div>
</template>

<script>
import "../css/headPage.css"
export default {
  name: "websiteHead",
  data() {
    return {
      nav_list:[
        {id:0,nav_name:'首页'},
        {id:1,nav_name:'行业新闻'},
        {id:2,nav_name:'产品信息'},
        {id:3,nav_name:'解决方案'},
        {id:4,nav_name:'关于微影'},
        ],
      hoverNavIndex:-1,         // 菜单选项覆盖
      currentMenuIndex:this.$parent.currentMenuIndex,
      HbackgroundURL:'',
    };
  },
  props:['titleCheckData'], // 当前激活的菜单id,由参数传入
  watch: {
  },
  mounted() {
  },
  methods: {
    login() {
      this.$router.push({name:'login',query: { pageName: 'index'} });
    },
    change_page(index) {
      this.$parent.currentMenuIndex = index;
      this.currentMenuIndex =index;
      this.$router.replace({path:'/index',query: { page: index}});
    },
    showNav() {
      // 父组件 显示菜单 开关
      if (this.$parent.show_mobile_nav) {
        this.$parent.show_mobile_nav = false;
      } else {
        this.$parent.show_mobile_nav = true;
      }
    },
  },
};
</script>

<style>
.imgzoIndex .sys-icons-user {
    height: calc(var(--pcHeadHeight) * 0.68);
    width: calc(var(--pcHeadHeight) * 0.68);
    border: 1px solid var(--PrimaryColor-7);
    border-radius: 50%;
    background: var(--PrimaryColor-1);
    margin: 2px;
    overflow: hidden;
}
.imgzoIndex .sys-icons-user .icons-user-size {
  width: 100%;
    height: 100%;
    background-size: 88%;
}

.imgzoIndex .sys-icons-menu {
    height: calc(var(--pcHeadHeight) - 8px);
    width: calc(var(--pcHeadHeight) - 8px);
    border: 1px solid var(--PrimaryColor-10);
    border-radius: 50%;
    margin: 2px;
    overflow: hidden;
}
.imgzoIndex .sys-icons-menu .icons-menu-size {
  width: 100%;
    height: 100%;
    background-size: 100%;
}

.headPage .logo-waveBox {
  position: absolute;height: var(--pcHeadHeight) ;width: 100%;overflow: hidden;
  --backgroundWaveTop:0vw;
  }
.headPage .logo-waveBox .wave {
    position: absolute;
    /* background-color: var(--PrimaryColor-10); */
    border-radius: 50%;
    mix-blend-mode: multiply;
    overflow: hidden;
}
.headPage .wave-c1 {
  top: 0vw;
    left: 0vw;
    width: 100vw;
    height: calc(var(--pcHeadHeight) * 2);
    background-color: var(--PrimaryColor-10);
}
.headPage .wave-c2  {
    top: calc(var(--pcHeadHeight) * 0.309);
    left: 0vw;
    width: 100vw;
    height: calc(var(--pcHeadHeight) * 2 *0.618);
    background-color: var(--PrimaryColor-10);
}
.headPage .wave-h1{
    top: 0px;
    left: 21.35vw;
    width: 57.3vw;
    height: calc(var(--pcHeadHeight) * 2);
    background-color: var(--PrimaryColor-10);
}
.headPage .wave-h2   {
    top: calc(var(--pcHeadHeight) * 0.764);
    left: 0vw;
    width: 100vw;
    height: calc(var(--pcHeadHeight) * 2 *0.236);
    background-color: var(--PrimaryColor-30);
}
.headPage .arrow-icon-mini{
    height: 100%;
    width: 16px;
    background-size: 16px 16px;
  }
  
.imgzoIndex .user_switch_window {
    position: absolute;
    top: 0px;
    right: 0px;
    height: 100vh;
    width: 100vw;
    background: var(--SecondColor-30);
    border: none;
}
.imgzoIndex .user_switch_window .user_switch_div {
  position: fixed;
    top: 40%;
    bottom: 40%;
    height: 20vh;
    width: 32vw;
    min-width: 320px;
    right: 36%;
    left: 36%;
    background: var(--WhiteColor-2);
    border-radius: 4px;
}
.imgzoIndex .user_switch_window .user_switch_div .user_switch_item {
    height: auto;
    padding: 16px 32px;
    border-radius: 4px;
    /* background: var(--PrimaryColor-9); */
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.imgzoIndex .user_switch_window .user_switch_div .user_switch_item .user_switch_radio_group {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.imgzoIndex .user_switch_window .user_switch_div .user_role_item {
    background: var(--PrimaryColor-9);
}
.imgzoIndex .user_switch_window .user_switch_div .user_hospital_item {
    background: var(--PrimaryColor-7);
}
.imgzoIndex .user_switch_window .el-radio {
  color: var(--WhiteColor-1);
  line-height: 200%;
}

</style>

